import React from "react";
import {FormattedMessage} from "react-intl";
import Icon from "../../Icon";
import Loader from "../../Loader";

import AccessControl from "../../../../hoc/AccessControl";

import classes from "./styles.module.css";

function Button({label, color, isLoading, isDisabled, icon, onClick, hasAccess}) {

    const styles = {
        backgroundColor: color,
        padding: Boolean(icon) ? ".4375rem .875rem .4375rem 1.875rem" : ".4375rem .875rem"
    }

    return <button onClick={() => onClick()} className={classes.Btn} style={styles} disabled={isLoading || isDisabled}>
        {Boolean(icon) && (
            isLoading ? (!isDisabled && <Loader isString={true}/>
            ) : (<Icon className={classes.Icon} icon={icon} size={'17px'}/>)
        )}
        <FormattedMessage id={label} defaultMessage="Перевод отсутствует"/>
    </button>
}

export default AccessControl(Button);



// WEBPACK FOOTER //
// ./src/Components/Utils/UI/Button/index.js